<template>
  <v-layout>
    <v-container grid-list-md>
      <v-card>
        <v-form ref="form">
          <v-card-title primary-title>
            Bulk SMS
            <v-spacer></v-spacer>
            <v-btn icon text color="green" v-if="!(sms_balance && site_online)" @click="reloadBalance()" :loading="smsloading">
              <v-icon>refresh</v-icon>
            </v-btn>
            <span>{{sms_balance && site_online ?sms_balance+" sms remaining":"no sms balance or network error"}}</span>
          </v-card-title>
          <v-card-text>
            <v-layout row wrap>
              <!-- title -->
              <v-flex xs12>
                <v-autocomplete
                  label="Send To:"
                  :items="receipients"
                  outlined
                  v-model="message_model.rcpts"
                  :rules="rules.required"
                ></v-autocomplete>
              </v-flex>

                 <v-flex xs12>
                <v-textarea
                  label="Enter Contact Numbers"
                  v-if="message_model.rcpts == 'Custom Contacts'"
                  outlined
                  v-model="custom_contact_list"
                  hint="Seperate contacts by commas eg. 0244111111,0502222222,0273333333"
                  :rules="rules.required"
                ></v-textarea>
              </v-flex>
              <v-flex
                xs12
                v-if="message_model.rcpts=='Top Customers'">
                <v-text-field
                  label="Top Customers Limit"
                  hint="Enter 10 for eg. to message top 10 customers"
                  outlined
                  :rules="rules.required"
                  v-model="topcust_limit"
                  type="number"
                  step="1"
                ></v-text-field>
              </v-flex>
              <!-- message box -->
              <v-flex xs12>
                <v-textarea
                  v-model="message_model.msg"
                  outlined
                  auto-grow
                  label="Message"
                  rows="4"
                  row-height="30"
                  shaped
                  counter
                  :rules="rules.required"
                ></v-textarea>
              </v-flex>
            </v-layout>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="success" @click="sendMsg()" :loading="busy">Send</v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-container>
    <snackbar ref="sb"></snackbar>
  </v-layout>
</template>



<script>
import { mapGetters } from "vuex";
import smsService from "../../services/sms-service";
import { error } from "util";
import snackbar from "../shared/snackbar";

export default {
  components: {
    snackbar
  },
  data() {
    return {
      busy: false,
      site_online: false,
      receipients: ["All Customers", "Top Customers", "All Staff","Custom Contacts"],
      ac_contacts: [], //all customers contacts
      tc_contacts: [], //top customers contacts
      staff_contacts: [],
      topcust_limit: "",
      custom_contact_list:"",
      rules: {
        required: [value => !!value || "Required."]
      },
      message_model: {
        rcpts: "",
        msg: ""
      },
      sms_senderid: "",
      sms_apiKey: ""
    };
  },
  created() {
    this.site_online = navigator.onLine ? true : false;
    this.$store.dispatch("settings/getAll");
    this.$store.dispatch("Customers/getAll");
    this.$store.dispatch("Users/getAll");

    this.sms_senderid = this.settings.sms.senderid;
    this.sms_apiKey = this.settings.sms.apiKey;
    if (this.site_online) {
      this.$store.dispatch("sms/getBalance", this.sms_apiKey);
    }
  },
  computed: {
    ...mapGetters({
      settings: "settings/SETTINGS",
      serrors: "settings/SETTING_ERROR",
      sloading: "settings/SETTING_LOADING",

      customers: "Customers/CUSTOMERS",
      staffs: "Users/USERS",

      sms_balance: "sms/SMS_BALANCE",
      smserrors: "sms/SMS_ERROR",
      smsloading: "sms/SMS_LOADING"
    })
  },

  methods: {
    snackbarconf(snackbar, message, color) {
      snackbar.text = message;
      snackbar.color = color;
      snackbar.snackbar = true;
    },
    reloadBalance(){
      this.$store.dispatch("sms/getBalance", this.sms_apiKey);
       this.site_online = navigator.onLine ? true : false;

       if(!this.site_online){
         this.$toast.warning("Please check your network");
       }
    },
    sendMsg() {
      var thesnackbar = this.$refs.sb;
      if (this.$refs.form.validate()) {
        if (!navigator.onLine) {
          this.snackbarconf(
            thesnackbar,
            "Sorry, message could not be sent, please check your internet connection.",
            "error"
          );
          return;
        }

        if (this.sms_balance < 1) {
          this.snackbarconf(
            thesnackbar,
            "Sorry,your balance is insufficient for this message. Please tell administrator to recharge sms balance.",
            "error"
          );
          return;
        }

        // this.busy = true;
        // var uname = this.settings.sms.username;
        // var pass = this.settings.sms.password;
        // var auth = "Bearer:" + btoa(uname + ":" + pass); //converting username and password to base64 encoded string with btoa() for bearer token

        let rcpts = [];
        let custom_rcpts = "";
        switch (this.message_model.rcpts) {
          case "All Customers":
            rcpts = this.ac_contacts;

            break;
          case "Top Customers":
            //console.log(this.topcust_limit);
            this.tc_contacts = this.ac_contacts
              ? this.ac_contacts.slice(0,parseInt(this.topcust_limit))
              : [];
            rcpts = this.tc_contacts;
             
            break;
          case "All Staff":
            rcpts = this.staff_contacts;
          case "Custom Contacts":
            let custCon = this.custom_contact_list
            let custConArray = custCon.split(',');

            if(this.sms_balance<custConArray.length){
              this.$toast.error("Your sms balance is less than the number of recipients for this message. Recipients:"+custConArray.length)
                 return
            }

         
            rcpts = custConArray;
            break;
        }

        // let payload = {
        //   auth: auth,
        //   msg: JSON.stringify({
        //     from: uname,
        //     to: rcpts,
        //     text: this.message_model.msg
        //   })
        // };

        // console.log("msgggg", payload.msg);

        // //sending sms
        // smsService
        //   .sendMsg(payload)
        //   .then(response => {
        //     console.log(response);
        //     this.busy = false;
        //   })
        //   .catch(err => {
        //     this.busy = false;
        //     console.log("err", err);
        //   });

        // console.log('rcccccc',rcpts.toString())
        // return

        if (rcpts && rcpts.length > 0) {
          this.$store.dispatch("sms/send", {
            key: this.sms_apiKey,
            to: rcpts.toString(),
            msg: this.message_model.msg,
            senderid: this.sms_senderid
          });

          if (this.smserrors == null) {
            this.message_model.msg = "";
            this.message_model.rcpts = "";
            this.custom_contact_list="";
            this.snackbarconf(thesnackbar, "SMS sent successfully", "success");

            setTimeout(() => {
              this.$store.dispatch("sms/getBalance", this.sms_apiKey);
            }, 3000);
          } else {
            this.snackbarconf(
              thesnackbar,
              "Sorry,An error occured whiles sending SMS.",
              "error"
            );
          }
        } else {
          this.snackbarconf(
            thesnackbar,
            "Sorry, SMS could not be sent. No recipients were found",
            "error"
          );
        }
      }
    }
  },
  watch: {
    customers(val) {
      this.ac_contacts = val
        ? val
            .filter(x => {
              //console.log("yipiiiiii", x);
              return x.cust_phone != null;
            })
            .map(val => val.cust_phone)
        : [];
    },
    staffs(val) {
      this.staff_contacts = val
        ? val
            .filter(x => {
              return x.phone != "";
            })
            .map(val => val.phone)
        : [];
    }
  }
};
</script>
